module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Paste_16"],"path":[{"$":{"d":"M13,11v3H0V4H4V6H2v6h9V11Zm3-9H5v8H16Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Paste_16.svg
// module id = X2JF
// module chunks = 1